import { create } from 'zustand';
import { IUser } from '../models/user.model';

interface UserState {
  isLogged: boolean;
  user: IUser | null;
  hasToken: boolean;
  updateToken: boolean;
  setUser: (user: any, isLogged?: boolean, hasToken?: boolean) => void;
  setUpdateToken: (hasUpdated: boolean) => void;
}

export const useUserStore = create<UserState>((set) => ({
  isLogged: false,
  hasToken: false,
  user: null,
  updateToken: false,
  setUser: (user: IUser, isLogged?: boolean, hasToken?: boolean) =>
    set({ user, isLogged: isLogged || true, hasToken: hasToken || true }),
  setUpdateToken: (hasUpdated: boolean) => set({ updateToken: hasUpdated }),
}));
